<h3 class="title">{{ "monitoring.title" | translate }}</h3>

<div class="p-1">
  <p-table
    #table
    class="i-table-v2"
    [value]="importFiles?.items ?? []"
    styleClass="p-datatable-striped"
    [tableStyle]="{ 'min-width': '50rem' }"
    [scrollable]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [rows]="pageSize"
    [first]="first"
    [paginator]="true"
    [lazy]="true"
    [loading]="loading"
    [totalRecords]="importFiles?.totalCount ?? 0"
    (onLazyLoad)="loadData($event)"
    currentPageReportTemplate="{{ 'monitoring.pagination' | translate }}"
  >
    <ng-template pTemplate="loadingicon">
      <i class="pi pi-spinner animate-spin"></i>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" style="min-width: 10rem">
          {{ "monitoring.table.nomFichier" | translate }}
        </th>
        <th scope="col">{{ "monitoring.table.dateImport" | translate }}</th>
        <th scope="col">{{ "monitoring.table.dateTraitement" | translate }}</th>
        <th scope="col">{{ "monitoring.table.userName" | translate }}</th>
        <th scope="col">{{ "monitoring.table.motifRejet" | translate }}</th>
        <th scope="col" [style]="{ maxWidth: '100px' }">
          {{ "monitoring.table.status" | translate }}
        </th>
        <th
          scope="col"
          style="width: 5rem"
          alignFrozen="right"
          pFrozenColumn
          [frozen]="true"
        ></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr>
        <td
          [pTooltip]="data.nomOriginalFichier"
          [tooltipPosition]="'right'"
          [fitContent]="true"
          style="min-width: 10rem; line-height: 1.1em"
        >
          {{ data.nomOriginalFichier }}
        </td>
        <td>{{ data.dateImport | date : "d/M/yy, HH:mm" }}</td>
        <td>{{ data.dateTraitement | date : "d/M/yy, HH:mm" }}</td>
        <td>{{ data.user }}</td>
        <td
          [pTooltip]="data.motifRejet"
          [tooltipPosition]="'top'"
          [fitContent]="true"
        >
          {{ data.motifRejet | slice : 0 : 20
          }}{{ data.motifRejet?.length > 20 ? "..." : "" }}
        </td>
        <td [style]="{ maxWidth: '100px' }">
          <span
            [class]="'badge'"
            [style]="{
              backgroundColor: data.statut.color,
              whiteSpace: 'wrap',
              textAlign: 'left',
              width: '100%'
            }"
          >
            {{ data.statut.label }}
          </span>
        </td>
        <td alignFrozen="right" pFrozenColumn [frozen]="true">
          <div class="d-flex justify-content-end gap-1">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="showFile(data)"
              [disabled]="data.statut.id === 4"
              [pTooltip]="'Voir fichier'"
              [tooltipPosition]="'left'"
            >
              <i class="bi bi-eye"></i>
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="selectRow(data)"
              [disabled]="data.statut.id === 4"
              [pTooltip]="'Voir le traitement du fichier'"
              [tooltipPosition]="'left'"
            >
              <i class="bi bi-stack"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr style="height: 46px" *ngFor="let _ of loadingArray">
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center">
          {{ "monitoring.noData" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Composant dialog pour afficher les détails du fichier -->
<app-file-details-dialog
  [(visible)]="displayDialog"
  [fileId]="selectedFileId"
  [fileName]="selectedFileName"
>
</app-file-details-dialog>
